<template>
  <div class="teacher">
    <div class="banner ban_title lecturer">
      <div class="con">
        <div class="con_person row">
          <div class="le">
            <div class="tupian_con">
              <div class="tupian row">
                <div class="img_per">
                  <img :src="global.getSrc(teacher.thumbs)" class="img-circle" width="100%">
                </div>
              </div>
            </div>
          </div>
          <div class="ri">
            <div class="row">
              <h3>{{teacher.name}}</h3>
            </div>
            <div class="row">
              <!-- <h5>{{teacher.company}}  <br class="mob">{{teacher.position}}</h5> -->
              <h5>{{teacher.company}}  {{teacher.position}}</h5>
            </div>
            <div class="row pc">
              <p v-html="teacher.desc"></p>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <p class="mob" v-html="teacher.desc"></p>
    </div>
    <div class="pc_content">
      <div class="con">
        <div class="le">
          <div class="img">
            <img src="../assets/img/before_train/train_course.png" />
          </div>
        </div>
        <div class="ri">
          <h3>即将开始的MPD课程</h3>
          <div class="teacher_jieshao">
            <slot v-if="teacher.thisCourse&&teacher.thisCourse[0]">
              <h1>{{teacher.thisCourse[0].title}}</h1>
              <h2>{{teacher.thisCourse[0].venueName}}</h2>
              <h2>{{global.formatTime(teacher.thisCourse[0].date,'Y-M-D')}}  {{teacher.thisCourse[0].startTime}}--{{teacher.thisCourse[0].endTime}}</h2>
              <p v-html="teacher.thisCourse[0].desc"></p>
            </slot>
            <slot v-else-if="!param.course_wd">
              <h1></h1>
              <h2></h2>
              <h2>敬请期待...</h2>
              <p></p>
            </slot>
            <slot v-else>
              <h1></h1>
              <h2></h2>
              <h2>本届MPD暂无分享议题，嘉宾将对大会整体议题甄选和议题质量进行把控和指导。</h2>
              <p></p>
            </slot>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teacher',
  props: {
    tid: {
      type: [String, Number],
      default: ''
    },
    param: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // param: {},
      teacher_id: '',
      teacher: {},
      metaInfo: {
        seoTitle: '讲师介绍',
        seoKeyword: '',
        seoDescription: ''
      }
    }
  },
  metaInfo () {
    // 这里的this可以访问到asyncData返回的数据
    const { metaInfo, teacher } = this
    const venueName = (teacher && teacher.thisCourse && teacher.thisCourse[0] && teacher.thisCourse[0].venueName) || ''
    return {
      title: metaInfo.seoTitle || `${this.teacher.name || ''} - MPD专家讲师`,
      meta: [
        { name: 'description', content: metaInfo.seoDescription || (teacher.desc || '').slice(0, 150) },
        { name: 'keywords', content: metaInfo.seoKeyword || venueName }
      ]
    }
  },
  created () {
    // console.log(1)
    // this.param = {...this.$route.query, ...this.$route.params}
    // this.teacher_id = (this.param.tid && parseInt(this.param.tid)) || ''
    // this.getTeacher()
  },
  watch: {
    // $route: {
    //   handler (to, from) { // 监听路由是否变化
    //     if (to.path && to.path.includes('teacher')) {
    //       let toOption = {...to.query, ...to.params}
    //       let fromOption = (from && {...from.query, ...from.params}) || {}
    //       let toTid = (toOption.tid && parseInt(toOption.tid)) || ''
    //       let fromTid = (fromOption.tid && parseInt(fromOption.tid)) || ''
    //       console.log(2)
    //       if (toTid && toTid !== fromTid && toTid !== this.teacher_id) {
    //         this.param = toOption
    //         this.teacher_id = toTid
    //         this.getTeacher()
    //       }
    //     }
    //   },
    //   immediate: true,
    //   deep: true // 深度监听
    // }
    tid: {
      handler (newId, oldId) {
        if (newId && newId !== oldId) {
          this.teacher_id = newId
          this.getTeacher()
        }
      },
      immediate: true
    }
  },
  methods: {
    getTeacher () {
      let turl = `${this.global.urlNew.lecturer}${this.global.area_id}/${this.teacher_id}`
      this.$http
        .jsonp(turl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if (data.errno === '0') {
            console.log('teacher ', data.data)
            this.teacher = data.data
            if (data.data.seo && data.data.seo !== null && !Array.isArray(data.data.seo)) {
              this.metaInfo = data.data.seo
            }
            if (this.metaInfo.seoTitle === '' || this.metaInfo.seoTitle === '讲师介绍') {
              this.metaInfo.seoTitle = (data.data.name ? (data.data.name + ' - ') : '') + 'MPD 专家讲师'
            }
          }
        })
    }
  }
}
</script>

<style lang="scss">
#app .teacher {
 .banner.ban_title {
  height: auto;
  min-height: 300px;
  .con {
   max-width: 1020px;
   margin: 0 auto;
   padding-top: 20px;
   .con_person {
    padding-bottom: 40px;
    display: flex;
    flex-wrap: nowrap;
    .le {
     width: 25%;
     padding: 0;
     .tupian_con {
      width: 80%;
      margin: 0 auto;
      margin-top: 30px;
      .tupian {
       border: 7px solid var(--main-bgcolor);
       border-radius: 50%;
       margin-left: 0;
       margin-right: 0;
       .img_per {
        width: 100%;
        margin: 0 auto;
        background-size: 100%;
        img{
         border: 5px solid #FFFFFF;
        }
       }
      }
     }
    }
    .ri {
     width: 75%;
     margin-top: 30px;
     .row{
      margin-left: 0;
      margin-right: 0;
      * {
       color: #FFFFFF;
       text-align: left;
      }
      h3 {
       height: 40px;
       line-height: 40px;
       font-size: 30px;
      }
      h5 {
       font-size: 16px;
       margin-top: 15px;
       margin-bottom: 17px;
      }
      p {
       line-height: 30px;
       font-size: 16px;
      }
     }
    }
   }
  }
 }
 .pc_content {
  .con {
   max-width: 1020px;
   margin-top: 100px;
   margin-bottom: 60px;
   .le {
    width: 10%;
    float: left;
    padding-left: 15px;
    .img img {
      background-color: var(--main-bgcolor);
    }
   }
   .ri {
    width: 89%;
    float: left;
    padding-left: 1%;
    padding-right: 1%;
    h3 {
     padding-top: 10px;
     padding-bottom: 10px;
     font-size: 30px;
    }
    .teacher_jieshao {
     width: 100%;
     padding-left: 10px;
     margin-top: 20px;
     margin-bottom: 20px;
     border-left: 4px solid var(--main-bgcolor);
     * {
      text-align: left;
     }
     h1 {
      font-size: 24px;
      padding-bottom: 14px;
     }
     h2 {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 1px;
      color: #333333;
     }
     p {
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 1px;
      padding-top: 15px;
      color: #666666;
     }
    }
   }
  }
 }
}
@media (max-width:767px) {
  // .year_before .teacher .banner.ban_title {
  //   background-image: url(../assets/img/2021/richeng/teacher_wap.png);
  // }
  // .year_after .teacher .banner.ban_title {
  //   background-image: url(../assets/img/2024/teacher_wap.png);
  // }
 .teacher {
  .banner.ban_title {
   height: auto;
   background-size: cover;
   .con {
    width: 100%;
    // height: auto;
    // min-height: 210px;
    // padding: 50px 10% 5px 10%;
    // padding-top: 50px;
    // background-color: var(--main-bgcolor);
    // background-image: url(../assets/img/2021/richeng/teacher_wap.png);
    height: fit-content;
    padding: 0;
    background-size: cover;
    .row {
     padding: 0 5%;
    }
    .con_person {
     padding-bottom: 0;
     display: block;
     .le {
      // width: 44%;
      // float: left;
      width: 100%;
      .tupian_con {
       width: 100%;
       width: 28%;
       min-width: 105px;
       max-width: 200px;
       margin: 0 auto;
       // margin-top: 0;
       margin-top: 15px;
       .tupian {
        border: none;
        margin-left: 0;
        margin-right: 0;
        .img_per {
         width: 100%;
         margin: 0 auto;
         background-size: 100%;
         position: relative;
         img {
          border-width: 3px;
         }
        }
       }
      }
     }
     .ri {
      // width: 55%;
      // float: left;
      // padding-left: 0;
      // padding-right: 0;
      // padding-left: 15px;
      // padding: 0 5%;
      width: 100%;
      margin-top: 0;
      .row {
       margin-left: 0;
       margin-right: 0;
       h3,h5 {
        font-size: 18px;
        // line-height: 22px;
        line-height: 1.1;
        height: 22px;
        text-align: center;
       }
       h3 {
         margin-top: 10px;
        //  font-size: 17px;
         font-size: 18px;
       }
       h5 {
        height: auto;
        margin-top: 0;
        margin-bottom: 0;
        // font-size: 14px;
        font-size: 15px;
        color: #cccccc;
       }
       p {
        display: none;
       }
      }
     }
    }
   }
   p.mob {
    width: 90vw;
    // font-size: 12px;
    // color: #666666;
    font-size: 13px;
    color: #dbdfe2;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: left;
    padding-top: 10px;
    // padding-left: 20px;
    // padding-right: 20px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;
    margin: 0 auto;
   }
  }
  .pc_content {
   .con {
    margin-top: 40px;
    .le {
     width: 0;
     padding-left: 0;
     .img {
      img {
       width: 40px;
       padding-left: 5px;
      }
     }
    }
    .ri {
     width: 100%;
     h3 {
      font-size: 24px;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-left: 45px;
     }
     .teacher_jieshao {
      border-width: 2px;
      h1 {
       font-size: 17px;
      }
      h2 {
       font-size: 12px;
      }
      p {
       font-size: 12px;
       line-height: 16px;
      }
     }
    }
   }
  }
 }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Teacher.vue